import {useOnResize, useOnScroll} from "../../utils";
import './Navbar.css'
import {useEffect, useState} from "react";
import Menu from "./Menu";
import persistToggleMenu from "./persistToggleMenu";
import upArrow from "../photos/up-arrow.png"
import logo from "../photos/pageIcon.png"


//On click to slide in menu bar
const Navbar = () => {
    const [isToggle, setToggle] = useState(false);
    const [isMobileView, setMobileView] = useState(false)

    let widthX = useOnResize()
    let height = useOnScroll()


    const scrollUp = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }


    const updateToggle = () => {
        let hr = document.getElementById('menu-toggleM').childNodes
        let main_overlay = document.getElementById("main-overlay")
        let hidden_overlay = document.getElementById("hidden-overlay")

        if (isToggle){
            setToggle(false)
            hr.forEach(bar => {bar.style.backgroundColor = 'darkgreen'})
            hidden_overlay.style.width = '0'
            main_overlay.style.minWidth = '0'
            main_overlay.style.width = '0'
        }
        else {
            setToggle(true)
            hr.forEach(bar => {bar.style.backgroundColor = 'darkorange'})
            hidden_overlay.style.width = '100%'
            main_overlay.style.minWidth = '320px'
            main_overlay.style.width = '40%'
        }
    }

    useEffect(() => {
        if (widthX > 850) {
            setMobileView(false)
        }
        else
            setMobileView(true)
        persistToggleMenu()
    }, [widthX, isMobileView])

    return(
        <div id = 'navbar'>
            <div id = 'title'>
                <div className= 'page-logo'>
                    <img src = {logo} alt = 'logo'/>
                </div>
            </div>
            {/*Full View*/}
            {!isMobileView && <div id='menu-main'> <Menu updateToggle={updateToggle} isMobile = {false} /> </div>}

            {/*Mobile View*/}
            {isMobileView && <div id ="menu-toggleM" onClick= {updateToggle}>
                <div className= 'hr'/>
                <div className= 'hr'/>
                <div className= 'hr'/>
            </div>
            }
            {isMobileView && <div className= 'overlay' id = 'hidden-overlay' onClick={updateToggle}> </div>}
            {isMobileView && <div className='overlay' id='main-overlay'>
                <div id='options'>
                    <div className='close-button' onClick={updateToggle}>
                        <div className='bar1'/>
                        <div className='bar2'/>
                    </div>
                    <div className='website-logo'>
                        <img alt = 'logo' src = {logo} />
                    </div>
                    {<div id='menu-mobile'>
                        <Menu updateToggle={updateToggle} isMobile = {true}/>
                    </div>}
                </div>
            </div>
            }
            {height > 100 && <div id='scrollUp' onClick={scrollUp}>
                <img src={upArrow} alt='^'/>
            </div>
            }
         </div>

    )

}


//when user go to the page it should update the style
window.onload = function () {
    persistToggleMenu()
}

//when user go through the history, the state should update the style
window.onpopstate = e => {
    persistToggleMenu()
}


export default Navbar;